"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var InputCheckboxes_styles_1 = __importDefault(require("./InputCheckboxes.styles"));
var InputCheckbox_1 = __importDefault(require("../InputCheckbox/InputCheckbox"));
var InputCheckboxes = function (_a) {
    var label = _a.label, id = _a.id, options = _a.options, columns = _a.columns, _b = _a.buttonStyle, buttonStyle = _b === void 0 ? false : _b, value = _a.value, valueChanged = _a.valueChanged;
    var _c = react_1.useState(value), chosen = _c[0], setChosen = _c[1];
    var toggleValue = function (value) {
        if (chosen.includes(value)) {
            setChosen(function (prevChosen) {
                var newChosen = prevChosen.filter(function (item) { return item !== value; });
                return newChosen;
            });
        }
        else {
            setChosen(function (prevChosen) {
                var newChosen = __spreadArrays(prevChosen, [value]);
                return newChosen;
            });
        }
    };
    react_1.useEffect(function () {
        valueChanged(id, chosen);
    }, [chosen]);
    react_1.useEffect(function () {
        setChosen(value);
    }, [value]);
    return (react_1.default.createElement(InputCheckboxes_styles_1.default, { columns: columns },
        react_1.default.createElement("p", { className: "label" }, label),
        react_1.default.createElement("div", { className: "checkboxes" }, options.map(function (option, index) { return (react_1.default.createElement(InputCheckbox_1.default, { buttonStyle: buttonStyle, key: index, label: option.label, id: option.value, checked: chosen.includes(option.value), valueChanged: function () { return toggleValue(option.value); } })); }))));
};
exports.default = InputCheckboxes;
